import * as styles from "./Heading2.scss";
import { SimpleComponent } from "./SimpleComponent";

export class Heading2 extends SimpleComponent {
    protected className = styles.heading2;
    protected tag = "h2";
}
